import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import config from "../Config";
import { HandleResponse } from "../functions/HandleResponse";
import { authFetch } from "../functions/authFetch";
import { useNavigate } from "react-router-dom";
import { useSingleFlight } from "../hooks/useSingleFlight";

const PaymentMethodsEdit = () => {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" | "error"
  const navigate = useNavigate();
  const runDelete = useSingleFlight();

  useEffect(() => {
    let cancelled = false;
    const fetchPaymentMethods = async () => {
      try {
        const token = Cookies.get("runner_app");
        const response = await authFetch(`${config.AUTH_API}/v1/get-payment-methods`, {
          method: "GET",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        });
        if (cancelled) return;
        await HandleResponse(response, navigate);
        const data = await response.json();
        if (!cancelled) setPaymentMethods(data.paymentMethods || []);
      } catch (error) {
        if (!cancelled) console.error("Error fetching payment methods:", error);
      }
    };
    fetchPaymentMethods();
    return () => { cancelled = true; };
  }, [navigate]);

  const handleDelete = (e) => {
    e.preventDefault();
    setMessage("");
    if (!selectedMethod) { setMessage("Please select a payment method to remove."); setMessageType("error"); return; }

    runDelete(async () => {
      setLoading(true);
      try {
        const token = Cookies.get("runner_app");
        const response = await authFetch(
          `${config.AUTH_API}/v1/delete-payment-method?paymentMethodId=${selectedMethod}`,
          { method: "DELETE", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
        );
        const data = await response.json();
        if (response.ok) {
          setPaymentMethods((prev) => prev.filter((m) => m.id !== selectedMethod));
          setSelectedMethod("");
          setMessage("Payment method removed.");
          setMessageType("success");
        } else {
          setMessage(data.error || "Failed to remove. Please try again.");
          setMessageType("error");
        }
      } catch {
        setMessage("Something went wrong. Please try again.");
        setMessageType("error");
      } finally {
        setLoading(false);
      }
    });
  };

  const cardBrandColor = (brand) => {
    const b = brand?.toLowerCase();
    if (b === "visa") return "#1a1f71";
    if (b === "mastercard") return "#eb001b";
    if (b === "amex") return "#007bc1";
    return "#374151";
  };

  return (
    <section className="acct-card">
      <div className="acct-card-header">
        <h2>Payment Methods</h2>
      </div>
      <div className="acct-card-body">
        {paymentMethods.length === 0 ? (
          <p className="acct-empty">No saved payment methods.</p>
        ) : (
          <form onSubmit={handleDelete}>
            <div className="acct-pm-list">
              {paymentMethods.map((method) => (
                <label
                  key={method.id}
                  className={`acct-pm-item ${selectedMethod === method.id ? "selected" : ""}`}
                >
                  <input
                    type="radio"
                    name="paymentMethod"
                    value={method.id}
                    checked={selectedMethod === method.id}
                    onChange={() => { setSelectedMethod(method.id); setMessage(""); }}
                    className="acct-pm-radio"
                  />
                  <span className="acct-pm-brand" style={{ color: cardBrandColor(method.brand) }}>
                    {method.brand?.toUpperCase()}
                  </span>
                  <span className="acct-pm-num">•••• {method.last4}</span>
                  <span className="acct-pm-expiry">Exp {method.exp_month}/{method.exp_year}</span>
                </label>
              ))}
            </div>
            {message && (
              <p className={`acct-msg ${messageType === "success" ? "acct-msg-success" : "acct-msg-error"}`}>
                {message}
              </p>
            )}
            <div className="acct-card-footer">
              <button
                type="submit"
                className="acct-danger-btn"
                disabled={loading || !selectedMethod}
              >
                {loading ? "Removing…" : "Remove selected"}
              </button>
            </div>
          </form>
        )}
      </div>
    </section>
  );
};

export default PaymentMethodsEdit;
